import { Country } from '@wix/package-picker-common';
import { AcceptedPaymentMethods as AcceptedPaymentMethodsUi } from '@wix/package-picker-components';
import * as React from 'react';
import { useQueriesHandler } from '../../../hooks';
import { PackagePickerApiClient } from '../../../providers';
import { AUTONOMOUS_COMPONENT_NAMES } from '../../../types';
const COMPONENT_NAME = AUTONOMOUS_COMPONENT_NAMES.ACCEPTED_PAYMENT_METHODS;
export const AcceptedPaymentMethods = _ref => {
  let {
    onInit,
    onLoad,
    onError
  } = _ref;
  const {
    useAcceptedPaymentMethods
  } = PackagePickerApiClient.hooks;
  const acceptedPaymentMethodsQuery = useAcceptedPaymentMethods({
    countryCode: Country.USA // TODO: Get country from request
  });
  const {
    data
  } = acceptedPaymentMethodsQuery;
  const {
    isSuccess
  } = useQueriesHandler({
    callbacks: {
      onLoad,
      onError,
      onInit
    },
    queries: {
      acceptedPaymentMethodsQuery
    },
    componentName: COMPONENT_NAME
  });
  if (!isSuccess) {
    return null;
  }
  const acceptedPaymentMethods = (data == null ? void 0 : data.acceptedPaymentMethods) ?? [];
  return /*#__PURE__*/React.createElement(AcceptedPaymentMethodsUi, {
    acceptedPaymentMethods: acceptedPaymentMethods
  });
};
//# sourceMappingURL=AcceptedPaymentMethods.js.map